import React, { useState, useEffect } from "react";
import QRCode from "qrcode.react";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import Countdown from "react-countdown";
import { useSnackbar } from "react-simple-snackbar";
import Modal from "./Modal";
import $ from 'jquery'; 


// import logo from "../../logo.svg";
// import sharetrip from "../../sharetrip.svg";
import STPayLogo from "./../../ST-Pay-logo.png";
// import qr from "../../QR.svg";
import "./Login.css";

import MerchantDetailsApi from "../../services/MerchantDetails.service";

import { pusherChanelForQR } from "../../utils/pusher";
import ErrorShow from "../ErrorShow";
// import TimeCountdown from "../TimeCountdown";
import { Link } from "react-router-dom";
import TermsAndConditions from "./TermsAndCondition";

const Login = () => {

  const [platform, setPlatform] = useState("desktop");
  const [currentPage, setCurrentPage] = useState("MobileNumber");
  const [mobileNum, setMobileNum] = useState("");
  const [otp, setOtp] = useState("");
  const [pin, setPin] = useState("");
  // start my code
  const [orderId, setOrderId] = useState("");
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState({});
  const [savedWallets, setSavedWallets] = useState([]);
  const [isSavedEnable, setIsSavedEnable] = useState(0);
  const [isFromSW, setIsFromSW] = useState(false);
  const [pay_type, set_pay_type] = useState("login");
  const [resendOtpCounter, setResendOtpCounter] = useState(0);
  const [countDownValue, setCountDownValue] = useState(300000);
  const [resendOtpTimer, setResendOtpTimer] = useState(process.env.REACT_APP_RESEND_OTP_TIMER ?? 30);
  const [errorToken, setErrorToken] = useState(false);
  const [currentTime, setCurrentTime] = useState("");


  const [isSaved, setIsSaved] = useState(0);


  useEffect(() => {
    if (currentPage !== "Otp") {
      return;
    }

    if (resendOtpTimer <= 0) {
      if (document.getElementById("resend_otp_timer_div")) {
        document.getElementById("resend_otp_timer_div").style.display = 'none';
        document.getElementById("resend_otp_div").style.display = 'block';
      }
      return;
    };

    const timerInterval = setInterval(() => {
      setResendOtpTimer(resendOtpTimer - 1);
    }, 1000);


    return () => clearInterval(timerInterval);

  }, [resendOtpTimer, currentPage]);


  const [open, setOpen] = useState(false);
  const handleClose = () => {
      setOpen(false);
  };


  

  const handleOpen = () => {
    setOpen(true);
  };


  const selectSavedWallet = (val) => {
    setIsSaved(0);
    $("#is_saved_cb").prop("checked",false);
    setMobileNum("");

    if( val === "" ) {
      setIsFromSW(false);
      $("#phone-div").addClass("d-flex");
      $("#phone-div").attr("style","");
      $("#save_option_div").attr("style","display:flex");
      return;
    }

    setIsFromSW(true);
    setMobileNum(val);
    $("#phone-div").removeClass("d-flex");
    $("#phone-div").attr("style","display:none");
    $("#save_option_div").attr("style","display:none");
    return;
  }



  // end my code
  const [openSnackbar, closeSnackbar] = useSnackbar({
    position: "top-right",
    style: {
      // backgroundColor: "#d35400",
      backgroundColor: "#e67e22",
      color: "#fff",
      fontSize: "16px",
      textAlign: "center",
    },
  });

  const [payMethod, setPayMethod] = useState("LoginToPay");

  const numericOnly = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (currentPage === "MobileNumber") {
      setMobileNum(value);
    } else if (currentPage === "Otp") {
      setOtp(value);
    } else {
      setPin(value);
    }
  };

  // function confirmNum(mobileNum) {
  //   if (mobileNum.length === 10) {
  //     setCurrentPage("Otp");
  //   }
  // }

  // function confirmOtp(otp) {
  //   if (otp.length === 6) {
  //     setCurrentPage("Pin");
  //   }
  // }

  // function confirmPin(pin) {
  //   if (pin.length === 4) {
  //     setCurrentPage("Pin");
  //   }
  // }


  const [isMobile, setIsMobile] = useState(0);
  useEffect(() => {
    window.addEventListener('resize', checkMobile);
    // window.addEventListener('load', checkMobile);
    checkMobile();
  }, []);


  const checkMobile = () => {
    const width = window.innerWidth;
    if (width <= 770) {
      setIsMobile(1);
    }
    else {
      setIsMobile(0);
    }
  }


  // start my code

  const fetchData = async () => {
    // setLoader(true);
    try {
      const url = window.location;
      const token = new URLSearchParams(url.search).get("token");

      const res = await MerchantDetailsApi.getSummery(token);
      const curtime = parseInt(countDownValue);

      if (res.data.code === 200) {
        // let time = moment().unix();
        let time = Date.now();

        setCurrentTime(time);

        // setLoader(false);
        // setStatus(200);
        // setMerchantSummery(res.data.data);
        // setQrString(res.data.data);
        let merchantSummery = res.data.data;
        setSummary(merchantSummery);
        setOrderId(res.data.data.order.id);
        setSavedWallets(res.data.data.saved_wallet ?? []);

        if( res.data.data.is_saved_enable === 'yes' ) {
          setIsSavedEnable(1);
        }




        pusherChanelForQR(
          merchantSummery.order.event,
          merchantSummery.order.channel,
          merchantSummery,
          pay_type
        );


        setTimeout(() => {
          window.location.assign(res.data.data.merchant.redirect_urls.cancel + "?order_id=" + merchantSummery?.order?.id);
        }, curtime);
      } else {
        setErrorToken(true);
        // setLoader(false);
      }
    } catch (error) {
      let msg = error.response.data?.messages[0].toString() ?? "";
      if (msg !== "") {
        openSnackbar(msg);
      }
      setErrorToken(true);
    }
  };


  const sendOtp = async () => {
    setLoading(true);

    if(!isFromSW) {
      if (mobileNum.length !== 11) {
        openSnackbar('Please enter valid mobile number.');
        setLoading(false);
        return;
      }
    }
    else {
      if (mobileNum.length !== 14) {
        openSnackbar('Please enter valid mobile number.');
        setLoading(false);
        return;
      }
    }


    let m = `+88${mobileNum}`;
    if(isFromSW) {
      m = mobileNum;
    }
    const url = window.location;
    const token = new URLSearchParams(url.search).get("token");
    const payload = {
      order_id: summary.order.id,
      token,
      mobile_number: m,
      is_save: isSaved
    };

    try {
      let res = await axios.post(
        `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/send-otp`,
        payload
      );
      // openSnackbar("else", res);
      if (res.data.code === 200) {
        setCurrentPage("Otp");
        setResendOtpTimer(process.env.REACT_APP_RESEND_OTP_TIMER ?? 30);
      } else {
        if (res.data?.messages[0] !== "") {
          openSnackbar(res.data?.messages[0]);
        }
      }
    } catch (error) {
      let err = error.response.data?.errors?.mobile_number[0];
      if (err) {
        openSnackbar(err);
      } else {
        let err2 = error.response?.data?.messages[0];
        openSnackbar(err2);
      }
    }

    setLoading(false);
  };

  const resendOtp = async () => {

    if (resendOtpCounter >= 1) {
      openSnackbar("Resend code limit exceed.");
      return;
    }


    setResendOtpCounter((prev) => prev += 1);

    setLoading(true);

    

    let m = `+88${mobileNum}`;
    if(isFromSW) {
      m = mobileNum;
    }

    const url = window.location;
    const token = new URLSearchParams(url.search).get("token");
    const payload = {
      order_id: summary.order.id,
      token,
      mobile_number: m,
      is_save: isSaved
    };

    try {
      let res = await axios.post(
        `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/resent-otp`,
        payload
      );

      if (res.data.code === 200) {
        setCurrentPage("Otp");
        openSnackbar("Successfully resend code");
        setResendOtpTimer(process.env.REACT_APP_RESEND_OTP_TIMER ?? 30);

        if (document.getElementById("resend_otp_timer_div")) {
          document.getElementById("resend_otp_timer_div").style.display = 'block';
          document.getElementById("resend_otp_div").style.display = 'none';
        }

      } else {
        openSnackbar(res.data?.messages[0] ?? "A problem occur. Please try again.");
      }
    }
    catch (ex) {
      openSnackbar("A problem occur. Please try again.");
    }

    setLoading(false);
    setResendOtpTimer(process.env.REACT_APP_RESEND_OTP_TIMER);
  };

  const VerifyOtp = async () => {


    if (otp.length !== 6) {
      openSnackbar("Please enter valid OTP.");
      return;
    }

    setLoading(true);

    
    let m = `+88${mobileNum}`;
    if(isFromSW) {
      m = mobileNum;
    }

    const url = window.location;
    const token = new URLSearchParams(url.search).get("token");
    const payload = {
      order_id: summary.order.id,
      token,
      mobile_number: m,
      otp: otp,
      is_save: isSaved
    };

    try {
      let res = await axios.post(
        `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/verify-otp`,
        payload
      );
      if (res.data.code === 200) {
        setCurrentPage("Pin");
      } else {
        if (res.data?.messages[0] !== "") {
          openSnackbar(res.data?.messages[0]);
        }
      }
    } catch (error) {
      let err = error.response.data?.errors?.otp[0] ?? "";
      if (err) {
        openSnackbar(err);
      } else {
        let err2 = error.response.data?.messages[0] ?? "";
        openSnackbar(err2);
      }
    }
    setLoading(false);
  };



  const onSubmit = async () => {
    setLoading(true);


    let m = `+88${mobileNum}`;
    if(isFromSW) {
      m = mobileNum;
    }

    const url = window.location;
    const token = new URLSearchParams(url.search).get("token");
    const payload = {
      order_id: summary.order.id,
      token,
      mobile_number: m,
      otp: otp,
      pin: pin,
      is_save: isSaved
    };

    try {
      let res = await axios.post(
        `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/execute`,
        payload
      );



      if (res.data.code === 200) {
        let order_id = summary.order.id;
        let s_url = new URL(summary.merchant.redirect_urls.success);
        s_url.searchParams.append("order_id", order_id);
        window.location.assign(s_url);
        return;
      }

      setLoading(false);



      let msg = res.data?.messages[0].toString() ?? "";
      if (msg.length > 0) {
        openSnackbar(msg);
      }

    } catch (error) {

      let err = error.response.data?.messages[0] ?? "";
      if (err.toString().length > 0) {
        openSnackbar(err);
      }

      setLoading(false);

    }



  };

  const handleCancel = () => {
    let order_id = summary.order.id;
    let c_url = new URL(summary.merchant.redirect_urls.cancel);
    c_url.searchParams.append("order_id", order_id);
    window.location.assign(c_url);
  };

  const Completionist = () => <span>Your time is over</span>;

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    } else {
      // Render a countdown
      return (
        <span>
          This page will timed out in {minutes} minutes {seconds} seconds
        </span>
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const validateNumber = (value) => {
    if (isNaN(value)) {
      return;
    }


    let phone = document.getElementById("phone").value;
    if (phone.length > 0) {
      phone = phone.toString();
      if (phone[0] !== "0") {
        return;
      }
    }




    setMobileNum(value);
  }

  // end my code

  return (
    <>
      {!errorToken ? (
        <div className="gateway">
          <div className="form-signin">
            {/* Header    */}

            <div className="w-full py-3 text-center bg-white" style={{ borderBottom: "1px solid rgba(23, 130, 253, 0.1)" }}>
              <img src={STPayLogo} className="h-[50px]" alt="ST Pay logo" />
            </div>

            <div className="container header px-4 py-0" style={{ borderBottom: "1px solid rgba(23, 130, 253, 0.1)" }}>
              <div className="top-left">
                {(summary.merchant?.logo) &&
                  <img src={summary.merchant?.logo} className="me-2 mt-3" alt="logo" style={{ maxWidth: "48px", maxHeight: "50px", border: "1px solid rgba(23, 130, 253, 0.1)", borderRadius: "5px" }} />
                }

                <div className="mt-3 lh-sm">
                  <h5 className="custom-title" style={{ paddingTop: "2px", marginBottom: "2px" }}>{summary?.merchant?.name}</h5>
                  <p className="text-secondary order-id">
                    Invoice No: {summary?.order?.id}
                  </p>
                </div>
              </div>
              <h3 className="fs-24 mt-2">
                {/* ৳ 5,000 */}
                {/* {summary?.order?.total_payable?.currency}{" "} */}
                ৳{" "}
                {number_format(summary?.order?.total_payable?.amount ?? 0)}
              </h3>
            </div>

            {/* <div className="container main text-center py-4 p-4 bg-white"> */}
            <div className="container main text-center p-0 bg-white">
              {(platform === "desktop" && isMobile === 0) && <>
                {(currentPage === "MobileNumber") && (
                  <div className="px-4 py-2 pt-3">
                    <p className="payment-method">How would you like to pay?</p>
                    <div className="d-flex p-1 justify-stretch" style={{ border: "1px solid #1782FD1A", borderRadius: "5px" }}>


                      <button
                        className={`w-50 btn login-or-qr rounded-sm py-2 fs-5 fw-500 ${payMethod === "LoginToPay" ? "active" : ""
                          }`}
                        onClick={() => {
                          setPayMethod("LoginToPay");
                          set_pay_type("login");
                        }}
                      >
                        Login to Pay
                      </button>

                      <button
                        className={`w-50 btn login-or-qr rounded-sm py-2 fs-5 fw-500 ${payMethod === "ScanQR" ? "active" : ""
                          }`}
                        onClick={() => {
                          setPayMethod("ScanQR");
                          set_pay_type("qr");
                        }}
                      >
                        Scan QR Code
                      </button>


                      {/* <input type="submit" className="w-50 btn btn-loginToPay rounded-0 py-2 fs-4" value="Login to Pay" />
                                <input type="submit" className="w-50 btn btn-lg btn-confirm fw-bold text-white rounded-0 fs-4" value="Scan QR Code" /> */}
                    </div>
                  </div>
                )}

              </>}


              {payMethod !== "ScanQR" &&

                <div className="px-4 mt-2 pb-3" style={{ background: "#1782FD0D" }}>

                  {currentPage === "MobileNumber" && payMethod === "LoginToPay" && (
                    <p className="fs-18 mt-4 pt-4">Your ST Pay Account Number</p>
                  )}

                  {currentPage === "Otp" && (
                    <p className="fs-18 mt-4 pt-4">6-digit code sent to {mobileNum}</p>
                  )}
                  {currentPage === "Pin" && <p className="fs-18  pt-3">Enter Your PIN</p>}

                  {/* Input Field */}

                  {currentPage === "MobileNumber" && payMethod === "LoginToPay" && (
                    <>


                      <div className="d-flex w-100" id="phone-div">
                        <div className="w-20 me-1">
                          <select
                            className="form-select py-3 fw-500"
                            aria-label="Default select example"
                          >
                            <option>+88</option>
                          </select>
                        </div>

                        <div className="form-floating mb-3 text-success w-80">
                          {/* <select><option>+880</option></select> */}
                          <input
                            name="phone"
                            type="tel"
                            className="form-control number"
                            id="phone"
                            autoComplete="off"
                            placeholder="Mobile number"
                            maxLength="11"
                            pattern="[0-9]*"
                            value={mobileNum}
                            onChange={(e) => validateNumber(e.target.value)}
                            required
                          />
                          <label htmlFor="phone">Mobile number</label>
                        </div>
                      </div>

                      


                      {(isSavedEnable === 1) && 
                        <>
                          {/* SAVE WALLET OPTION */}
                          {(savedWallets.length < 5) && 
                          <div id="save_option_div">
                            <div className='option_label'>
                                <p className='title'>Save this wallet</p>
                            </div>
                            <div className='option_radio'>
                                <label className="toggle">
                                    <input id="is_saved_cb" className="toggle-checkbox" type="checkbox" 
                                    onClick={() => setIsSaved((prevState) => !prevState)} value={isSaved} />
                                    <div className="toggle-switch"></div>
                                    <span className="toggle-label"></span>
                                </label>
                            </div>
                          </div>
                          }

                          {/* SELECT EXISTING ACCOUNT */}
                          <div id='saved_wallet_div'>
                              <div id='saved_wallet_div_header'>
                                  <p><strong>Select saved wallet</strong></p>
                                  <p><strong>{savedWallets.length}</strong> out of <strong>5</strong>&nbsp;</p>
                              </div>
                              <div className='pt-2'>
                                  <select id='saved_wallet_div_selector' onChange={(event)=>selectSavedWallet(event.currentTarget.value)} defaultValue={""}>  
                                    <option value="" style={{fontSize: "14px"}}>Choose Existing Account</option>
                                    {savedWallets.map((val, i) => {
                                      return (<option key={i} value={val?.user?.mobile_no}>{val.wallet_no}</option>) 
                                    })}

                                  </select>
                              </div>
                          </div>
                        </>
                      }

                    </>
                    


                  )}

                  {currentPage === "Otp" && (
                    <div className="form-floating mb-3 text-success w-100">
                      <input
                        name="otp"
                        type="tel"
                        className="form-control"
                        id="otp"
                        placeholder="OTP"
                        maxLength="6"
                        value={otp}
                        onChange={numericOnly}
                        required
                      />
                      {/* <input value={otp} onChange={handleChange} /> */}
                      <label htmlFor="otp">OTP</label>
                    </div>
                  )}
                  {currentPage === "Pin" && (
                    <div className="form-floating mb-3 text-success">
                      <input
                        name="pin"
                        type="password"
                        pattern="[0-9]*"
                        inputMode="numeric"
                        className="form-control"
                        id="pin"
                        placeholder="PIN"
                        maxLength="4"
                        value={pin}
                        onChange={numericOnly}
                        required
                      />
                      <label htmlFor="pin">PIN</label>
                    </div>
                  )}



                  {currentPage === "MobileNumber" && payMethod === "LoginToPay" && (
                    <p className="fs-14 mb-0 pb-3 text-center">
                      By clicking on <span className="fw-bold">Confirm,</span> <br />
                      You are agreeing to the{" "}
                      <span onClick={handleOpen}
                        className="text-body fw-600" style={{ textDecoration: "underline", cursor: "pointer" }}
                      >
                        Terms & Conditions
                      </span>{" "}
                    </p>
                  )}
                  {(currentPage === "Otp" && resendOtpCounter === 0) && (
                    <p className="fs-14 mb-2" style={{ display: "flex", justifyContent: "center" }}>
                      Didn't get the code? {" "}
                      <span id="resend_otp_timer_div" style={{ paddingLeft: "5px" }}>
                        Resend in <strong id="counter">{resendOtpTimer}</strong> seconds
                      </span>
                      <span className="text-body fw-600" style={{ display: "none", marginLeft: "5px", cursor: "pointer" }} id="resend_otp_div" onClick={resendOtp}>
                        Resend code
                      </span>{" "}
                    </p>
                  )}
                </div>
              }
            </div>


            {payMethod === "ScanQR" && (
              <div className="text-center bg-white">
                <div className="pb-3" style={{ background: "rgba(23, 130, 253, 0.05)" }}>
                  <QRCode
                    style={{ background: "rgba(23, 130, 253, 0.05)", marginTop: "23px" }}
                    // className="w-75"
                    size={193}
                    value={summary.order?.qr_text}
                  />
                </div>
              </div>
            )}

            {/* Button */}

            {currentPage === "MobileNumber" && payMethod === "LoginToPay" && (
              <div className="d-flex">
                <input type="button"
                  className="w-50 btn btn-lg button-close fw-bold text-white rounded-0 py-2 fs-5"
                  value="Close"
                  onClick={handleCancel}
                />
                {!loading ? (
                  <input type="button"
                    className="w-50 btn btn-lg btn-confirm fw-bold text-white rounded-0 py-2 fs-5"
                    value="Confirm"
                    onClick={sendOtp}
                  />
                ) : (
                  <div className="w-50 btn btn-lg btn-confirm fw-bold text-white rounded-0 py-0 fs-6">
                    <Spinner
                      animation="border"
                      style={{ position: "relative", top: 10 }}
                    />
                  </div>
                )}
              </div>
            )}
            {currentPage === "Otp" && (
              <div className="d-flex">
                {!loading ? (
                  <input type="button"
                    className="w-100 btn btn-lg btn-confirm fw-bold text-white rounded-0 py-2 fs-5"
                    value="Continue"
                    onClick={VerifyOtp}
                  />
                ) : (
                  <div className="w-100 btn btn-lg btn-confirm fw-bold text-white rounded-0 py-2 fs-5">
                    <Spinner
                      animation="border"
                      style={{ position: "relative", top: 5 }}
                    />
                  </div>
                )}
                {/* <input className="w-100 btn btn-lg btn-confirm fw-bold text-white rounded-0 fs-4 py-3" onClick={() => setCurrentPage("Pin")}>Confirm</input> */}
              </div>
            )}
            {currentPage === "Pin" && (
              <div className="d-flex">
                {!loading ? (
                  <input
                    className="w-100 btn btn-lg btn-confirm fw-bold text-white rounded-0 py-2 fs-5"
                    value="Confirm"
                    onClick={onSubmit}
                  />
                ) : (
                  <div className="w-100 btn btn-lg btn-confirm fw-bold text-white rounded-0 py-2 fs-5">
                    <Spinner
                      animation="border"
                      style={{ position: "relative", top: 5 }}
                    />
                  </div>
                )}
                {/* <input className="w-100 btn btn-lg btn-confirm fw-bold text-white rounded-0 fs-4 py-3" onClick>Confirm</input> */}
              </div>
            )}
            {payMethod === "ScanQR" && (
              <input type="button"
                className="w-100 btn btn-lg button-close fw-bold text-white rounded-0 py-2 fs-5"
                value="Close"
                onClick={handleCancel}
              />
            )}

            {/* footer */}

            <footer className="container text-secondary text-center py-3">
              <p style={{ marginBottom: 0, fontSize: 12, color: "#999" }}>
                <Countdown
                  date={currentTime + countDownValue}
                  renderer={renderer}
                ></Countdown>
              </p>
              {/* Powered by <img src={logo} className="mb-2" alt="Deshi logo" /> */}
            </footer>
          </div>
        </div>
      ) : (
        <ErrorShow />
      )}
      <Modal isOpen={open} onClose={handleClose}>
        <TermsAndConditions></TermsAndConditions>
      </Modal>

      <style>{`

        .gateway {
            background: #FFF;
        }

        .form-signin {
            border: 1px solid rgba(23, 130, 253, 0.1);
        }

        .payment-method {
          font-size: 17px;
          opacity: .9;
        }

        .login-or-qr {
          font-size: 18px !important;
          font-weight: 600 !important;
          padding-block: 10px !important;
        }

        .login-or-qr.active {
            background: #1882FF !important;
            opacity: .9;
        }

        label, .form-select {
          color: #1782FD !important;
        }

        input, select {
          background: #E9F2FF !important;
        }

        .form-floating>.form-control-plaintext~label::after, .form-floating>.form-control:focus~label::after, .form-floating>.form-control:not(:placeholder-shown)~label::after, .form-floating>.form-select~label::after {
          background: transparent !important;
          color: #1782FD  !important;
        }


        @media only screen and (max-width: 600px) {
          .form-select.py-3.fw-500 {
            padding-inline: 5px;
          }

          .custom-title, .order-id {
            font-size: 15px;
          }

          .fs-24.mt-2 {
            font-size: 17px;
          }

          .top-left img {
            max-width: 40px !important;
            max-height: 40px !important;
          }

          .d-flex.w-100 {
            justify-content: center;
          }

          .gateway {
            padding: 20px;
            overflow-y: scroll;
          }
        }
          
          @media only screen and (max-width: 480px) { 
            .top-left img {
              max-width: 70px !important;
              max-height: 70px !important;
            }
          
            .container.header.px-4.py-0 {
              display: block;
            }
            .top-left {
              display: block;
              text-align:center;
            }
            .fs-24.mt-2 {
              text-align:center;
              font-size: 20px;
            }

            .top-left img.me-2.mt-3 {
              margin-left: 10px;
            }

            .form-select.py-3.fw-500 {
              padding-inline: 0px;
            }


          }

          @media only screen and (max-width: 310px) {
            .d-flex.w-100 {
              display: block !important;
            }

            .form-select.py-3.fw-500 {
              text-align: center;
              margin-bottom: 5px;
              padding-inline: 5px;
            }

            .form-floating.mb-3.text-success.w-80 {
              width: 98%;
            }
          }
          
        



      `}</style>

    </>
  );


  function number_format(number, decimals, dec_point, thousands_point) {
    if (number == null || !isFinite(number)) {
      throw new TypeError("number is not valid");
    }

    if (!decimals) {
      var len = number.toString().split('.').length;
      decimals = len > 1 ? len : 0;
    }

    if (!dec_point) {
      dec_point = '.';
    }

    if (!thousands_point) {
      thousands_point = ',';
    }

    number = parseFloat(number).toFixed(decimals);

    number = number.replace(".", dec_point);

    var splitNum = number.split(dec_point);
    splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_point);
    number = splitNum.join(dec_point);

    return number;
  }



};

export default Login;
